const SplashImage = () => {
  return (
    <img className={"NavBar-logo"} src="/images/Company-Logo-Splash_V2_1920.png" alt="Unlimited therapy logo" width={'100%'}/>
  );
}

export default SplashImage;
